import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type AnnotationAcknowledgmentState = {
  acknowledgedIds: Set<string>;
};

const initialState: AnnotationAcknowledgmentState = {
  acknowledgedIds: new Set(),
};

export const useAnnotationAcknowledgmentStore = create(
  immer<AnnotationAcknowledgmentState>(() => ({ ...initialState })),
);

export const getAcknowledgedAnnotationIds = (): Array<string> => {
  return Array.from(useAnnotationAcknowledgmentStore.getState().acknowledgedIds);
};

export const isAnnotationAcknowledged = (annotationId: string): boolean => {
  return useAnnotationAcknowledgmentStore.getState().acknowledgedIds.has(annotationId);
};

export const resetAnnotationAcknowledgments = () => {
  useAnnotationAcknowledgmentStore.setState({ acknowledgedIds: new Set() });
};

export const toggleAnnotationAcknowledgment = (annotationId: string) => {
  const current = useAnnotationAcknowledgmentStore.getState().acknowledgedIds;
  const next = new Set(current);
  if (next.has(annotationId)) {
    next.delete(annotationId);
  } else {
    next.add(annotationId);
  }
  useAnnotationAcknowledgmentStore.setState({ acknowledgedIds: next });
};
